import React from "react";
import "./skills.css";

const Backend = () => {
    return (
        <div className="skills__content">
        <h3 className="skills__title">Languages/Frameworks</h3>
        
        <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                <i className ='bx bx-badge-check'></i>

                <div>
                    <h3 className="skills__name">Python</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
                </div>

                <div className="skills__data">
                <i className = 'bx bx-badge-check'></i>

                <div>
                    <h3 className="skills__name">C/C++</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
                </div>

                <div className="skills__data">
                <i className='bx bx-badge-check'></i>

                <div>
                    <h3 className="skills__name">Java</h3>
                    <span className="skills__level">Basic</span>
                </div>
                </div>

                <div className="skills__data">
                <i className ='bx bx-badge-check'></i>

                <div>
                    <h3 className="skills__name">SQL</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
                </div>

                <div className="skills__data">
                <i className ='bx bx-badge-check'></i>

                <div>
                    <h3 className="skills__name">Tensorflow</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
                </div>
            </div>

            <div className="skills__group">
                <div className="skills__data">
                <i className= 'bx bx-badge-check'></i>

                <div>
                    <h3 className="skills__name">PySpark</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
                </div>

                <div className="skills__data">
                <i className ='bx bx-badge-check'></i>

                <div>
                    <h3 className="skills__name">PyFlink</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
                </div>

                <div className="skills__data">
                <i className = 'bx bx-badge-check'></i>

                <div>
                    <h3 className="skills__name">Kafka</h3>
                    <span className="skills__level">Basic</span>
                </div>
                </div>

                <div className="skills__data">
                <i className = 'bx bx-badge-check'></i>

                <div>
                    <h3 className="skills__name">Numpy</h3>
                    <span className="skills__level">Intermediate</span>
                </div>
                </div>

                <div className="skills__data">
                <i className ='bx bx-badge-check'></i>

                <div>
                    <h3 className="skills__name">Keras</h3>
                    <span className="skills__level">Basic</span>
                </div>
                </div>

                
            </div>
        </div>
    </div>
    )
}

export default Backend